export const DEFAULT_COLORS = ['#ed4b4b', '#e5059a', '#fa9d0d'];
export const DEFAULT_TEXT_COLOR = '#fff';

const FASHION_COLORS = ['#f595cc', '#d1549c', '#8f2d8e'];
const BEAUTY_COLORS = ['#af804b', '#83548c', '#ff0bd1'];
const NEWS_COLORS = ['#95aec7', '#7ba5d0', '#95c2f0'];
const HEALTH_COLORS = ['#5fb9db', '#ef4b4b', '#bf5253'];
const ENTERTAINMENT_COLORS = ['#96cbca', '#5b466d', '#bb8e57'];
const HOROSCOPES_BODY_SOUL_COLORS = ['#fb9f0d', '#fa6641', '#5f58bf'];
const WORK_MONEY_LIFESTYLE_COLORS = ['#b9b6a1', '#aca786', '#98b7b8'];
const WATCH_COLORS = ['#5c3e86', '#8068db', '#c42cc4'];

/*
 * The CTA bar, the tricolor line, and the about module all utilize the
 * same set of colors, so they nicely match. A color set includes 4 values:
 * 3 background colors and one text color. For the soft launch, all premium
 * channels should have their own defined custom color set, while every
 * other channel uses a default color set.
 */

/*
 * All the objects in the `CHANNEL_COLORS` array include:
 *   * `id` - a premium channel ID
 *   * `colors` - an array of three background color values
 *   * `text_color` - a string for the text color value
 */

/*
 * Channels that don't have a defined custom color set will use the
 * `DEFAULT_COLORS` and `DEFAULT_TEXT_COLOR` values.
 */

const US_CHANNELS = [
  {
    id: 36, // Homepage
    colors: DEFAULT_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 948, // Fashion
    colors: FASHION_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 949, // Beauty
    colors: BEAUTY_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 924, // Money Diaries
    colors: ['#8167bf', '#9778d3', '#ac96e2'],
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 151, // 67%
    colors: ['#f25f3b', '#fd7453', '#fa9f88'],
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 971, // Unstyled
    colors: ['#d2bd9c', '#c2ab87', '#b39c77'],
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 616, // Horoscopes
    colors: HOROSCOPES_BODY_SOUL_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 83, // US News
    colors: NEWS_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 953, // Entertainment
    colors: ENTERTAINMENT_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 993, // RSVP
    colors: ['#98b3a1', '#9bbebc', '#85b1af'],
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 115, // Short Cuts
    colors: ['#a8a2d0', '#908abb', '#7771a4'],
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1013, // Features
    colors: ['#b8aacb', '#e2505e', '#9bcaec'],
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 67, // Work & Money
    colors: WORK_MONEY_LIFESTYLE_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 65, // Food & Drink
    colors: ['#ce912d', '#9da018', '#ee5d24'],
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 952, // Health
    colors: HEALTH_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 60, // Make-up
    colors: ['#f5a887', '#e1d09d', '#abc8cb'],
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1122, // Unbothered
    colors: ['#f8ab2b', '#f14d4c', '#9e1d6f'],
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 76, // Sex
    colors: ['#e03f3f', '#bf5253', '#701b2e'],
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1155,
    colors: WATCH_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  }
];

const UK_CHANNELS = [
  {
    id: 963, // Fashion
    colors: FASHION_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 964, // Beauty
    colors: BEAUTY_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 966, // Health
    colors: HEALTH_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 967, // Entertainment
    colors: ENTERTAINMENT_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 968, // News
    colors: NEWS_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1156,
    colors: WATCH_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  }
];

const DE_CHANNELS = [
  {
    id: 957, // Fashion
    colors: FASHION_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 958, // Beauty
    colors: BEAUTY_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 959, // Body & Soul
    colors: HOROSCOPES_BODY_SOUL_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 960, // Lifestyle
    colors: WORK_MONEY_LIFESTYLE_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 961, // Entertainment
    colors: ENTERTAINMENT_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 962, // News
    colors: NEWS_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1157,
    colors: WATCH_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  }
];

const FR_CHANNELS = [
  {
    id: 1225, // Homepage
    colors: DEFAULT_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1330, // Fashion
    colors: FASHION_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1331, // Beauty
    colors: BEAUTY_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1332, // Body & Soul
    colors: HOROSCOPES_BODY_SOUL_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1333, // Lifestyle
    colors: WORK_MONEY_LIFESTYLE_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1334, // Entertainment
    colors: ENTERTAINMENT_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  }
];

const CA_CHANNELS = [
  {
    id: 1268, // Fashion
    colors: FASHION_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1269, // Beauty
    colors: BEAUTY_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1270, // News
    colors: NEWS_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1272, // Living
    colors: WORK_MONEY_LIFESTYLE_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1274, // Entertainment
    colors: ENTERTAINMENT_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 1275, // Health
    colors: HEALTH_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  }
];

const AU_CHANNELS = [
  {
    id: 10548493, // Beauty
    colors: BEAUTY_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 10556436, // News
    colors: NEWS_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 10556456, // Entertainment
    colors: ENTERTAINMENT_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 10556440, // Wellness en-au/health
    colors: HEALTH_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  },
  {
    id: 10534104, // Work-and-Money
    colors: WORK_MONEY_LIFESTYLE_COLORS,
    text_color: DEFAULT_TEXT_COLOR
  }
];

export const CHANNEL_COLORS = [
  ...US_CHANNELS,
  ...UK_CHANNELS,
  ...DE_CHANNELS,
  ...FR_CHANNELS,
  ...CA_CHANNELS,
  ...AU_CHANNELS
];
